import { RefObject, useEffect, useRef } from "react"
import { useClientCameraRotation } from '../../../hooks/useCameraClientRotation'
import { ClientApi } from '../../../services/clientApi'
import { useStore } from "../../../store/store"
import { NuiCallbacks } from '../../../utils/ClientEvents'
import './MoveZone.css'

interface MoveZoneProps {
    carId: number
    styles?: React.CSSProperties
    onMouseMove?: React.MouseEventHandler<HTMLDivElement>
    onClick?: React.MouseEventHandler<HTMLDivElement>
}

export const MoveZone = ({ carId, styles, onMouseMove, onClick }: MoveZoneProps) => {
    const carIdRef = useRef(carId)
    useEffect(() => {
        carIdRef.current = carId
    }, [carId])

    const sendRotate = (deltaX: number, deltaY: number, zoom: number) => {
        const currentUserId = useStore.getState().userId

        if (currentUserId == null) {
            console.warn('sendRotate skipped: userId is null')
            return
        }
        if (Math.abs(deltaX) <= 2 && Math.abs(deltaY) <= 2 && Math.abs(zoom) <= 2) return
        ClientApi.send(NuiCallbacks.ROTATE, {
            uid: currentUserId,
            cid: carIdRef.current,
            dx: deltaX,
            dy: deltaY,
            dz: zoom
        })
    }

    const rotationAreaRef = useRef<HTMLDivElement | null>(null)
    useClientCameraRotation<HTMLDivElement>({
        rotationAreaRef: rotationAreaRef as RefObject<HTMLDivElement>,
        mode: 'relative-offset',
        onMove: ({ x, y, zoom }) => {
            sendRotate(x, y, zoom)
        },
    })

    return (
        <div
            ref={rotationAreaRef}
            className="car-move-zone"
            style={styles}
            onMouseMove={onMouseMove}
            onClick={onClick}
        />
    )
}